import React, { useState } from 'react';

import { EditableSession } from 'types/event.types';
import { Icon } from '@epoch-ui/components/Icon';
import { Button } from '@epoch-ui/components/Button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@epoch-ui/components/Select/select';

interface GuestsSessionSelectorProps {
  sessions: EditableSession[];
  onChange: (id: number) => void;
}

const GuestsSessionSelector: React.FC<GuestsSessionSelectorProps> = ({ sessions, onChange }) => {
  const [value, setValue] = useState(sessions[0]?.id?.toString());

  const currentIndex = sessions.findIndex((session) => session.id?.toString() === value);
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === sessions.length - 1;

  const handlePrevious = (): void => {
    if (currentIndex > 0) {
      setValue(sessions[currentIndex - 1].id?.toString());
      onChange(Number(sessions[currentIndex - 1].id));
    }
  };

  const handleNext = (): void => {
    if (currentIndex < sessions.length - 1) {
      setValue(sessions[currentIndex + 1].id?.toString());
      onChange(Number(sessions[currentIndex + 1].id));
    }
  };

  return (
    <div className="tw-flex tw-items-center tw-gap-4">
      <Select
        value={value}
        onValueChange={(v) => {
          setValue(v.toString());
          onChange(Number(v));
        }}
      >
        <SelectTrigger className="tw-mr-2 tw-flex-1 tw-leading-5">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {sessions?.map((session) => (
            <SelectItem key={session.id} value={session.id?.toString() || ''}>
              {session.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        variant="ghost"
        size="sm"
        className="tw-p-0"
        onClick={handlePrevious}
        disabled={isFirst}
      >
        <Icon name="chevron-left" className="tw-h-6 tw-w-6" />
      </Button>
      <div className="tw-leading-5">
        {currentIndex + 1} of {sessions.length}
      </div>
      <Button variant="ghost" size="sm" className="tw-p-0" onClick={handleNext} disabled={isLast}>
        <Icon name="chevron-right" className="tw-h-6 tw-w-6" />
      </Button>
    </div>
  );
};

export { GuestsSessionSelector };
